var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcDataDelayAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc_data_delay_alerts_svg__clip0_1269_1503)",
    fill: "#515864"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.205 14.696c0-.088.008-.175.017-.271H3.282a1.91 1.91 0 01-.635-.114L9.03 8.217l1.977 1.694a.615.615 0 00.801 0l1.977-1.694 2.456 2.34c.191-.367.418-.725.662-1.057l-2.186-2.087 6.366-5.475c.313.367.505.83.505 1.345v2.9c.4-.114.8-.202 1.219-.263V3.283A3.302 3.302 0 0021.483.646S21.457.63 21.44.62a3.255 3.255 0 00-1.925-.629H3.283c-.714 0-1.385.236-1.925.629-.017.009-.026.017-.043.035A3.29 3.29 0 00-.01 3.292v9.063c0 1.04.488 1.965 1.237 2.576.017.018.035.027.052.035a3.258 3.258 0 001.994.681h11.974a8.762 8.762 0 01-.052-.96l.009.009zM3.283 1.222h16.24c.158 0 .314.027.462.053l-8.577 7.37L2.82 1.283c.148-.035.305-.053.462-.053v-.009zM1.219 12.364V3.292c0-.515.192-.978.505-1.345L8.09 7.422l-6.453 6.173a2.038 2.038 0 01-.418-1.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.451 7.859c-3.614 0-6.548 2.942-6.548 6.566 0 3.624 2.934 6.566 6.549 6.566 3.613 0 6.548-2.942 6.548-6.566 0-3.624-2.935-6.566-6.549-6.566zM26.1 18.162l-3.632-2.82v-4.637h1.298v4.008l3.126 2.428-.792 1.03v-.009z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dc_data_delay_alerts_svg__clip0_1269_1503"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v21H0z"
  })))));
}
export default SvgDcDataDelayAlerts;